/**
 * @file logsConstants.js
 * @description Constants for the Logs module.
 *              Includes UI label strings, table configurations, messages, and error constants.
 *
 * @module logsConstants
 *
 * @exports CALLLOG_STRINGS   - UI label strings for the call log panel.
 * @exports CALLLOG_KEYS      - Key mappings for call log data.
 * @exports CALLLOG_TABLE_COLUMNS - Column definitions for the call log table.
 * @exports CALLLOG_TABLE_COLUMN_KEYS - Column key mappings for the call log table.
 * @exports CALLLOG_MESSAGES  - Message strings for call log operations.
 * @exports CALLLOG_ERRORS    - Error message strings for call log data fetching.
 */
export const CALLLOG_STRINGS = {
    CALLS: "Permissions",
    SEARCH_PAGE: "Search Page",
    SEARCH_CALLS: "Search Logs",
    SAVE_CALLS: "Save Permissions",
    MODULE: "Module",
    PAGE: "Page"
};

export const CALLLOG_KEYS = {
    CALL_NAME: "callconnectionid"
}

export const CALLLOG_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "callconnectionid", isSortable: true, label: "Call ID" },
    { id: "customeracsid", isSortable: true, label: "Caller" },
    { id: "createdAt", isSortable: true, label: "Date" },
    { id: "blobfilename", isSortable: true, label: "Recording File" },
  /*   { id: "agentfirstname", isSortable: true, label: "agentfirstname" },
    { id: "agentlastname", isSortable: true, label: "agentlastname" },
    { id: "customerlastname", isSortable: true, label: "customerlastname" },
    { id: "customerfirstname", isSortable: true, label: "customerfirstname" }, */
    { id: "agentfullname", isSortable: true, label: "Agent" },
    { id: "customerfullname", isSortable: true, label: "Customer" },
    { id: "correlationId", isSortable: true, label: "Correlation ID" }
];

export const CALLLOG_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    CALL_ID: "callconnectionid"
};


export const CALLLOG_MESSAGES = {
    NO_CALLS: "No calls to display",
    NO_PAGES: "No pages found for this call."
};

export const CALLLOG_ERRORS = {
    FETCH_CALLS_ERROR: "Error fetching calls."
};
